import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

export default function Tooltip({
     children,
     className = '',
     wrapperClass = '',
     data = '',
     condition = true
}) {
     const isChildString = typeof children === 'string';
     const tooltipData = data || (isChildString ? children : '');
     const hasTooltipClass = (tooltipData && condition && 'tooltip') || '';

     return condition && tooltipData ? (
          <div className={`${hasTooltipClass} ${wrapperClass}`} tooltip-data={tooltipData}>
               <span className={isChildString && className}>{children}</span>
          </div>
     ) : (
          <>{children}</>
     );
}

Tooltip.propTypes = {
     children: PropTypes.any,
     wrapperClass: PropTypes.string,
     className: PropTypes.string,
     data: PropTypes.string,
     condition: PropTypes.bool
};
